var _path;
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8zm5.6 2h-1.044c-1.387.637-2.931 1-4.556 1s-3.163-.363-4.556-1H14.4A8.402 8.402 0 006 30.4V33a3 3 0 003 3h22a3 3 0 003-3v-2.6c0-4.637-3.762-8.4-8.4-8.4z"
  })));
}
export default SvgUser;